export enum Screen {
    Dashboard = 'Dashboard',
    Operations = 'Operations',
    UserAccess = 'Access Management',
    CreateTask = 'Create Task',
    ManualTaskV2 = 'Manual Tasks',
    GenerateReport = 'Reports',
    GlobalSearch = 'Global Search',
}

export const SCREEN_ROUTES: Record<Screen, string> = {
    [Screen.Dashboard]: '/',
    [Screen.Operations]: '/operations',
    [Screen.UserAccess]: '/users',
    [Screen.CreateTask]: 'create',
    [Screen.ManualTaskV2]: '/tasks',
    [Screen.GenerateReport]: '/reports',
    [Screen.GlobalSearch]: '/global-search',
};

export const ROUTES_TO_SCREEN: Record<string, Screen> = {
    '/': Screen.Dashboard,
    '/operations': Screen.Operations,
    '/users': Screen.UserAccess,
    '/create': Screen.CreateTask,
    '/tasks': Screen.ManualTaskV2,
    '/reports': Screen.GenerateReport,
    '/global-search': Screen.GlobalSearch,
};
